import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface EventId {
  accountNumber: string;
  accountName: string;
}

export interface Props {
  children?: FC;
  item?: EventId;
}

const SourceAccountCell: FC<Props> = ({
  item = {
    accountNumber: '',
    accountName: '',
  },
}) => {
  const { accountName, accountNumber } = item;
  const sourceAccount = accountName && accountNumber ? `${accountNumber} - ${accountName}` : '';
  return (
    <DataTableCell title={sourceAccount || ''}>
      <p
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          margin: 0,
        }}
      >
        {sourceAccount}
      </p>
    </DataTableCell>
  );
};

export default SourceAccountCell;
